// @ignore-coverage

import('./renderer');
